import { Trans } from '@lingui/react/macro';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import { Alert, Card, CardContent, Stack, Typography, useTheme } from '@mui/material';
import { branding } from '../branding';

interface NextStepsDocumentsProps {
  depositPaid: boolean;
}

export const NextStepsDocuments = ({ depositPaid }: NextStepsDocumentsProps) => {
  const theme = useTheme();
  const { orgEmail, orgPhone } = branding;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Stack direction="row" alignItems="center" gap={1} mb={1.5}>
          <CheckBoxOutlinedIcon />
          <Typography>
            <Trans>Next Steps</Trans>
          </Typography>
        </Stack>

        {depositPaid ? (
          <Alert severity="info" variant="outlined">
            <Typography variant="body2">
              <Trans>Your initial deposit has been processed successfully.</Trans>
            </Typography>
          </Alert>
        ) : (
          <Alert severity="info" variant="outlined">
            <Typography variant="h2" fontWeight={600} sx={{ pb: 1 }}>
              <Trans>🎉 Thank you! We've received your information</Trans>
            </Typography>
            <Typography variant="body2" sx={{ pb: 1 }}>
              <Trans>You're all set! We’ll now prepare the next steps in your application journey.</Trans>
            </Typography>
            <Typography variant="body2" sx={{ pb: 1 }}>
              <Trans>
                Soon, you’ll receive your contract from our team. Once it’s signed and your deposit is paid, we’ll continue by collecting additional personal
                information, your school grades, and other documents needed to complete your application.
              </Trans>
            </Typography>
            <Typography variant="body2" sx={{ pb: 1 }}>
              <Trans>There’s nothing more you need to do right now, just keep an eye on your inbox.</Trans>
            </Typography>
            <Typography fontWeight={600} sx={{ pb: 1 }}>
              <Trans>Have questions?</Trans>
            </Typography>
            <Typography variant="body2" sx={{ pb: 1 }}>
              <Trans>
                Just email <a href={`mailto:${orgEmail}`}>{orgEmail}</a> or call <a href={`tel:${orgPhone}`}>{orgPhone}</a>, we’re happy to help!
              </Trans>
            </Typography>
          </Alert>
        )}

        <Stack
          direction="row"
          sx={{ backgroundColor: theme.palette.menuColor, borderRadius: theme.spacing(1) }}
          justifyContent="space-between"
          gap={1}
          mt={1.5}
          p={2}
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <TaskOutlinedIcon sx={{ color: theme.palette.primary.main }} />
            <Stack>
              <Typography variant="h3" fontSize="18px">
                <Trans>Completed</Trans>
              </Typography>
              <Typography variant="caption" color={theme.palette.secondary.main}>
                <Trans>All steps complete</Trans>
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
